import React, { useEffect, useState } from 'react'
import { Modal, Select } from 'antd'
import { Button } from 'components/Button'
import { connect } from 'react-redux'
import { Heading } from 'components/Typography'
import { getStudentsDetailsById } from 'actions/userManagement'
import { fetchAutocompleteCoursesList, fetchCourseBatches, transferStudentToStandard } from 'actions/userManagementV2'

// Moves the student from the class they are in to another batch, which may belong to a
// different course. The class they came from is passed in, not read from redux.
const TransferClassModal = ({ open, onCancel, currentStandard, userDetailsById, autocompleteCoursesData, fetchAutocompleteCoursesList, fetchCourseBatches, transferStudentToStandard, getStudentsDetailsById }) => {

        const [courseBatches, setCourseBatches] = useState({});
        const [selectedCourse, setSelectedCourse] = useState(currentStandard?.courseId || null);
        const [selectedClass, setSelectedClass] = useState(null);
        const [selectedSection, setSelectedSection] = useState(null);
        const [transferLoader, setTransferLoader] = useState(false);

        useEffect(() => {
                if (open) {
                        fetchAutocompleteCoursesList({ emptySearch: true, names: true, fromCourse: true }, () => { });
                        // start from the course the student is already in
                        if (currentStandard?.courseId) {
                                fetchCourseBatches(currentStandard.courseId, (batches) => setCourseBatches(batches || {}));
                        }
                }
        }, [open]);

        // live courses and batches the student already has
        const takenCourseIds = (userDetailsById?.student?.userAssignedCourses || [])
                .filter((course) => course?.courseType === 'course').map((course) => course?.courseId);
        const takenStandardIds = userDetailsById?.student?.standardIds || [];

        // only a live course has batches, and only one with a batch can be transferred into
        // the current course stays, so they can move to another batch of it
        const liveCourses = autocompleteCoursesData?.filter(
                (item) => item?.itemType === 'course' && parseInt(item?.standardCount) > 0
                        && (item?.itemId == currentStandard?.courseId || !takenCourseIds.some((id) => id == item?.itemId))
        ) || [];
        // show the course only once it is in the list, so the raw id never flashes
        const courseValue = liveCourses.find((item) => item?.itemId == selectedCourse)?.itemId;

        // batches the student is already in are not transfer targets; a batch with none left is dropped
        const openSections = (batchName) => (courseBatches?.[batchName] || [])
                .filter((item) => item?.id != currentStandard?.standardId && !takenStandardIds.some((id) => id == item?.id));
        const openBatches = Object.keys(courseBatches).filter((batchName) => openSections(batchName).length > 0);
        const sectionsOfSelectedClass = selectedClass ? openSections(selectedClass) : [];

        const handleTransfer = () => {
                setTransferLoader(true);
                transferStudentToStandard(
                        {
                                standardId: currentStandard?.standardId,
                                targetStandard: selectedSection,
                                students: [userDetailsById?.id],
                        },
                        () => setTransferLoader(false),
                        () => {
                                onCancel();
                                getStudentsDetailsById(() => { }, userDetailsById?.id);
                        }
                );
        };

        return (
                <Modal
                        centered
                        closable
                        open={open}
                        footer={null}
                        className='modal-round-corner'
                        onCancel={onCancel}
                >
                        <center>
                                <Heading>Transfer a class</Heading>

                                <div style={{ padding: 20, textAlign: 'left' }}>
                                        <div className='simGrey bold-600'>Course</div>
                                        <Select
                                                placeholder='Select a course'
                                                style={{ width: '100%', marginBottom: 20 }}
                                                value={courseValue}
                                                onChange={(value) => {
                                                        setSelectedCourse(value);
                                                        setSelectedClass(null);
                                                        setSelectedSection(null);
                                                        setCourseBatches({});
                                                        fetchCourseBatches(value, (batches) => setCourseBatches(batches || {}));
                                                }}
                                        >
                                                {liveCourses?.map((item) => (
                                                        <Select.Option key={item?.itemId} value={item?.itemId}>{item?.name}</Select.Option>
                                                ))}
                                        </Select>

                                        <div className='simGrey bold-600'>Batch</div>
                                        <Select
                                                placeholder='Select a batch'
                                                notFoundContent='No batches found'
                                                style={{ width: '100%', marginBottom: 20 }}
                                                value={selectedClass}
                                                disabled={!selectedCourse}
                                                onChange={(value) => {
                                                        setSelectedClass(value);
                                                        setSelectedSection(null);
                                                }}
                                        >
                                                {openBatches.map((batchName) => (
                                                        <Select.Option key={batchName} value={batchName}>{batchName}</Select.Option>
                                                ))}
                                        </Select>

                                        <div className='simGrey bold-600'>Section</div>
                                        <Select
                                                placeholder='Select a section'
                                                notFoundContent='No sections found'
                                                style={{ width: '100%' }}
                                                value={selectedSection}
                                                disabled={!selectedClass}
                                                onChange={(value) => setSelectedSection(value)}
                                        >
                                                {sectionsOfSelectedClass?.map((item) => (
                                                        <Select.Option key={item?.id} value={item?.id}>{item?.section}</Select.Option>
                                                ))}
                                        </Select>

                                        <center>
                                                <Button onClick={handleTransfer} loading={transferLoader} disabled={!selectedSection} type='primary' style={{ marginTop: 40 }}>TRANSFER</Button>
                                        </center>
                                </div>
                        </center>
                </Modal>
        )
}

const mapStateToProps = (state) => {
        const { userDetailsById } = state.userManagement;
        const { autocompleteCoursesData } = state.userManagementV2;
        return { userDetailsById, autocompleteCoursesData };
};

const mapDispatchToProps = (dispatch) => ({
        fetchAutocompleteCoursesList: (params, callBack) => dispatch(fetchAutocompleteCoursesList(params, callBack)),
        fetchCourseBatches: (courseId, callBack) => dispatch(fetchCourseBatches(courseId, callBack)),
        transferStudentToStandard: (params, callback, successCallback) => dispatch(transferStudentToStandard(params, callback, successCallback)),
        getStudentsDetailsById: (callback, id) => dispatch(getStudentsDetailsById(callback, id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferClassModal)
